import React, { useEffect, useState, useRef } from 'react'
import { fechaActual } from '../../../hooks/UseDate';
import { postModificarFirmaMedico } from '../../../services/Clinico';

const ModalSubirImagenFirmaMedico = ({setmodalOnSubirFirma,informacionMedico, setactualizarData}) => {
    const handleCancelarClick=()=>{
        setmodalOnSubirFirma(false)
    }

    const [file, setFile] = useState(null); // Estado para almacenar el archivo seleccionado 
  const [error, setError] = useState('Seleccionar un Archivo'); // Estado para almacenar el mensaje de error
  const fileInputRef = useRef(null); // Referencia al input de tipo file
  const [loading, setloading]=useState(true)

  const allowedTypes = ['image/png', 'image/jpeg']; // Tipos de archivos permitidos
  const maxSize = 5 * 1024 * 1024; // Tamaño máximo del archivo (5 MB)

  // Manejar la selección del archivo
  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];

    // Verificar si el archivo es de tipo permitido y no excede el tamaño máximo
    if (selectedFile && (!allowedTypes.includes(selectedFile.type) || selectedFile.size > maxSize)) {
      setError('Solo se pueden subir imágen que no pesen más de 5 MB');
      fileInputRef.current.value = null; // Reset file input
      return;
    }

    // Verificar si ya hay un archivo seleccionado
    if (file) {
      setError('Solo se puede subir un archivo a la vez');
      fileInputRef.current.value = null; // Reset file input
      return;
    }

    setError(''); // Limpiar el mensaje de error
    setFile({ file: selectedFile, progress: 0, status: 'pending' }); // Almacenar el archivo seleccionado
    fileInputRef.current.value = null; // Reset file input
  };

  // Manejar el evento de arrastrar y soltar sobre el área
  const handleDragOver = (e) => {
    e.preventDefault();
  };

  // Manejar el evento de soltar el archivo
  const handleDrop = (e) => {
    e.preventDefault();
    const droppedFile = e.dataTransfer.files[0];

    // Verificar si el archivo es de tipo permitido y no excede el tamaño máximo
    if (droppedFile && (!allowedTypes.includes(droppedFile.type) || droppedFile.size > maxSize)) {
      setError('Solo se pueden subir imágen que no pesen más de 5 MB');
      return;
    }

    // Verificar si ya hay un archivo seleccionado
    if (file) {
      setError('Solo se puede subir un archivo a la vez');
      return;
    }

    setError(''); // Limpiar el mensaje de error
    setFile({ file: droppedFile, progress: 0, status: 'pending' }); // Almacenar el archivo seleccionado
  };

  // Simular el progreso de la carga del archivo
  useEffect(() => {
    if (file) {
      const interval = setInterval(() => {
        setFile((prevFile) => {
          if (prevFile.progress >= 100) {
            clearInterval(interval);
            return { ...prevFile, progress: 100 };
          }
          return { ...prevFile, progress: prevFile.progress + 10 };
        });
      }, 100);

      return () => clearInterval(interval);
    }
  }, [file]);

  // Función para subir el archivo
  const uploadFile = () => {
    if(!error || file){
      if (!file || file.status !== 'pending') return;

      const reader = new FileReader();

       // Convierte el archivo a Base64
    reader.readAsDataURL(file.file);

    reader.onload = () => {
      // Asegúrate de que reader.result sea una cadena válida antes de dividirla
      if (typeof reader.result === 'string' && reader.result.includes(',')) {
        const base64File = reader.result; 
        console.log(base64File, 'base64'); // Muestra la cadena Base64 en la consola
        const guardarFirma={
          'MMCedM': informacionMedico.MMCedM,
          'MMFIRMA':base64File
        }
        setloading(false)
      postModificarFirmaMedico(guardarFirma).then((res)=>{ 
        setloading(true)
        setactualizarData(guardarFirma)
        setmodalOnSubirFirma(false)
      })
        
      } else {
        console.error("Error: el archivo no se ha convertido a Base64 correctamente");
      }
    };
      

     
    }
    
  };

  // Obtener el ícono según el tipo de archivo
  const getFileTypeIcon = (fileType) => {
    if (!fileType) return null;
   
    if (fileType.includes('png') || fileType.includes('jpeg')) {
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-6 w-6 text-blue-500"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M4 2a2 2 0 00-2 2v12a2 2 0 002 2h12a2 2 0 002-2V8l-6-6H4zm3 12a1 1 0 100-2 1 1 0 000 2zm1-7V3.5L14.5 9H9a1 1 0 01-1-1z"
            clipRule="evenodd"
          />
        </svg>
      );
    }
    return null;
  };

  const handleClickEliminarArchivo=()=>{
    setFile(null)
    setError('Seleccionar Archivo')
  }
  return (
    <div
      className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
      id="exampleModalScrollable"
      tabIndex="-1"
      aria-labelledby="exampleModalScrollableLabel"
      aria-hidden="true"
    >
      <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
        <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
          <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
            <h5
              className="text-xl font-medium leading-normal text-white"
              id="exampleModalScrollableLabel"
            >
              Subir Imágen Firma
            </h5>
            <button
              type="button"
              onClick={handleCancelarClick}
              className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              X 
            </button>
          </div>

        

<div className="flex flex-col items-center mt-3">
  {/* <div className='flex mb-3'>
<div className="  w-1/2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                N° Documento
              </label>
              <div className="flex">
                <input
                  disabled={true}
                  defaultValue={informacionMedico.MMCedM}
                  name="codigo"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            <div className="ml-3  w-1/2">
              <label
                htmlFor="exampleFormControlInput1"
                className="form-label inline-block mb-2 text-gray-900 font-medium text-base	"
              >
                Paciente
              </label>
              <div className="flex">
                <input
                  disabled={true}
                  defaultValue={informacionMedico.MMNomM}
                  name="codigo"
                  type="text"
                  className="form-control  block w-full  px-3 py-0.5  text-base font-normal
                              text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300
                              rounded transition ease-in-out m-0  focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none  "
                  id="exampleFormControlInput1"
                  placeholder=""
                  autoComplete='off'
                />
              </div>
            </div>
            </div> */}
      <div
        className="border-dashed border-2 border-gray-400 rounded-lg p-6 text-center cursor-pointer w-80 mb-4"
        onDragOver={handleDragOver}
        onDrop={handleDrop}
        onClick={() => fileInputRef.current.click()}
      >
        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          className="hidden"
        />
        <div className="text-blue-500 mb-2">
          





<svg xmlns="http://www.w3.org/2000/svg" className="mx-auto text-blue-500" width="24" height="24" viewBox="0 0 24 24"><path d="M10 9h-6l8-9 8 9h-6v11h-4v-11zm11 11v2h-18v-2h-2v4h22v-4h-2z"/></svg>

        </div>
        <p className="text-gray-600">Arrastra y suelta archivos para subir o</p>
        <button className="mt-2 px-4 py-2 bg-blue-500 text-white rounded">
          Examinar
        </button>
        <p className="text-gray-400 mt-2 text-sm">
          Archivos soportados: PNG, JPEG (máx. 5 MB)
        </p>
      </div>
      {error && <p className="text-red-500 mb-4">{error}</p>}
      {file && (
        <div className="w-full max-w-lg">
          <h2 className="text-lg font-bold mb-2">Archivo seleccionado</h2>
          <ul>
            <li className="flex items-center justify-between mb-2 p-2 border rounded-lg bg-white">
              <div className="flex items-center">
                <span className="mr-2">
                  {getFileTypeIcon(file.file.type)}
                </span>
                <p className="truncate w-40">{file.file.name}</p>
              </div>
              <div className="w-32">
                <ProgressBar progress={file.progress} />
              </div>
              <button
                className="ml-2 text-red-500"
                onClick={() => handleClickEliminarArchivo()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                  strokeWidth={2}
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </li>
          </ul>
        </div>
      )}
      
    </div>
          

          <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
            <button
              type="button"
              onClick={handleCancelarClick}
              className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
              data-bs-dismiss="modal"
            >
              Cerrar
            </button>
            <button
              type="button"
              onClick={uploadFile}
              className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
            >
              Guardar
            </button>
          </div>
        </div>
      </div>
      {
                              loading?
                              null:
                              <div className="relative flex items-center justify-center h-screen">
            <div className="fixed top-0 left-0 flex items-center justify-center w-full h-full bg-slate-900 bg-opacity-25" style={{ pointerEvents: "auto" }}>
                <div className="flex flex-col items-center justify-center p-6 bg-white rounded shadow-lg">
                    <div className="w-16 h-16 border-t-4 border-blue-500 rounded-full animate-spin"></div>
                    <p className="mt-4 text-lg">Cargando</p>
                </div>
            </div>
            <div className="absolute top-0 left-0 w-full h-full" style={{ pointerEvents: "none" }}></div>
        </div>
                            }
    </div>
  )
}

const ProgressBar = ({ progress }) => {
    return (
      <div className="w-full bg-gray-200 rounded-full h-2.5">
        <div
          className="bg-blue-600 h-2.5 rounded-full"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    );
  };

export default ModalSubirImagenFirmaMedico